import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
const COVER_IMAGE = 'https://cdn.magicpatterns.com/uploads/4K3DGajw8RBxZt9YF86Wxj/ChatGPT_Image_Feb_6,_2026,_05_01_10_PM.png';
export function PricingSection() {
  return <Section id="pricing" background="night-900" className="relative" data-id="element-58">
      <div className="absolute inset-0 bg-gradient-to-b from-night-950 to-night-900 pointer-events-none" data-id="element-59" />

      <div className="relative z-10 max-w-lg mx-auto" data-id="element-60">
        <div className="text-center mb-10" data-id="element-61">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-62">
            Price & Access
          </h2>
          <p className="text-slate-400" data-id="element-63">
            This is a simple entry audio. No mandatory program. No forced
            upsells. Just one audio designed to help you understand what you're
            actually dealing with.
          </p>
        </div>

        <div className="bg-night-800 border-2 border-gold-500 rounded-2xl p-8 shadow-[0_0_40px_rgba(212,168,83,0.15)] relative overflow-hidden" data-id="element-64">
          {/* Decorative glow */}
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-gold-500/20 blur-[60px] rounded-full pointer-events-none" data-id="element-65" />

          <div className="flex flex-col items-center text-center mb-8" data-id="element-66">
            <img src={COVER_IMAGE} alt="The Sleep Fix — The Taproot Protocol" className="w-48 h-48 rounded-lg border border-gold-500/20 shadow-xl mb-6 object-cover" data-id="element-67" />

            <div className="text-5xl font-serif text-white font-bold mb-2" data-id="element-68">
              $7
            </div>
            <div className="text-slate-400 text-sm uppercase tracking-wider" data-id="element-69">
              One-time payment
            </div>
          </div>

          <ul className="space-y-4 mb-8" data-id="element-70">
            <li className="flex items-center gap-3 text-slate-200" data-id="element-71">
              <div className="w-5 h-5 rounded-full bg-gold-500/20 flex items-center justify-center" data-id="element-72">
                <div className="w-2 h-2 rounded-full bg-gold-500" data-id="element-73" />
              </div>
              Instant digital access
            </li>
            <li className="flex items-center gap-3 text-slate-200" data-id="element-74">
              <div className="w-5 h-5 rounded-full bg-gold-500/20 flex items-center justify-center" data-id="element-75">
                <div className="w-2 h-2 rounded-full bg-gold-500" data-id="element-76" />
              </div>
              Listen on any device
            </li>
            <li className="flex items-center gap-3 text-slate-200" data-id="element-77">
              <div className="w-5 h-5 rounded-full bg-gold-500/20 flex items-center justify-center" data-id="element-78">
                <div className="w-2 h-2 rounded-full bg-gold-500" data-id="element-79" />
              </div>
              Lifetime access
            </li>
          </ul>

          <Button className="w-full text-lg py-4 mb-6" glow data-id="element-80">
            GET INSTANT ACCESS NOW FOR JUST $7 →
          </Button>

          <div className="flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-81">
            <ShieldCheck className="w-4 h-4" data-id="element-82" />
            <span data-id="element-83">Secure 256-bit SSL Encrypted Payment</span>
          </div>
        </div>

        {/* Guarantee */}
        <div className="mt-16 text-center border border-white/10 bg-night-950/50 rounded-xl p-8" data-id="element-84">
          <h3 className="font-serif text-2xl text-white mb-4" data-id="element-85">
            100% Money-Back Guarantee
          </h3>
          <p className="text-slate-400 text-sm leading-relaxed mb-4" data-id="element-86">
            Listen to the full audio. If it doesn't shift your perspective on
            what's actually causing your insomnia, email us within 30 days for a
            full refund. No questions asked.
          </p>
          <p className="text-slate-500 text-xs italic" data-id="element-87">
            At $7, the guarantee isn't really about the money. It's about
            signaling that we stand behind what we're offering.
          </p>
        </div>
      </div>
    </Section>;
}